import $ from 'jquery'
import { createAlert } from 'dom/window'
// import { fetchJSONData } from '_utils';
import {
  axiosInstance as axios,
  createAxiosCancellationToken,
  handleAxiosErrors,
  debounceDispatchFunction,
  breakListIntoChunks,
} from '../_utils'
import config from 'store/_config'
import { requestCart as requestCheckoutCart } from '../actions/checkoutActions'
import {
  requestProductPriceByID,
  requestProductsByIDs,
  requestProductsByVariationID,
  toggleProductReplacementsLoading,
  requestProductRules,
} from '../actions/productsActions'
import { setUserCredentials } from '../actions/userActions'
import { getProductsFullInfo, getCartCount, getCurrentLoyaltyPoints } from '../selectors/defaultSelectors'
import { closeProductGridModal } from './productGridModalActions'
import { generateCartItem } from '../reducers/CartReducer'
import { removeBackOrderMultiItems, setBackorderList } from './backorderActions'
import { requestProductDeals } from './promoDealsActions'
import {
  combineCartBackOrderData,
  generateCartItemPayload,
  getCartTotalPoints,
  getBackorderIdsSupplier,
  getFilterBackorder,
} from '../selectors/cartSelectors'
import {
  segmentTrackCartViewed,
  segmentTrackProductAdded,
  segmentTrackProductRemoved,
  segmentTrackWishlistProductAddedToCart,
} from '../utils/segment/ecommerce'
import { handleErrorMessage } from '../../main/_utils'
import { togglePriceLoading } from './orderTemplateActions'

let cancelToken = {}

export const requestFromServer = () => {
  return async (dispatch, getState) => {
    let state = getState()
    const customerID = typeof state.user.user != 'undefined' ? state.user.user : 0
    dispatch(toggleCartLoading(true))

    const { hideBackOrderSuppliers } = state?.user?.globalConfig

    return Promise.all([axiosRequestCartFromServer(), axiosRequestBackOrderFromServer()])
      .then(async (allResponses) => {
        const processedResponse = getProcessedDataFromServerResponse(allResponses)
        const { cart, cartId, backorder, products } = processedResponse

        const filterBackorder = getFilterBackorder(backorder, hideBackOrderSuppliers)

        if (Object.keys(backorder).length > 0 && hideBackOrderSuppliers?.length > 0) {
          const Ids = getBackorderIdsSupplier(backorder, hideBackOrderSuppliers)
          await dispatch(removeBackOrderMultiItems(filterBackorder, Ids))
        }

        // Store Products
        const requiredBuyableIDs = Object.keys(products)
        const chunkedList = breakListIntoChunks(requiredBuyableIDs, 100)

        chunkedList.map(async (chunkedProductIDs) => {
          await dispatch(
            requestProductsByIDs({
              products: chunkedProductIDs,
            })
          )
        })

        const processedCartLoyaltyPointsResponse = processeCartLoyaltyPointsFromServerResponse(allResponses)
        const { pointsEarned, statusCredits } = processedCartLoyaltyPointsResponse

        // Store Data
        return Promise.all([
          // Store Cart, list
          dispatch(setCartList(cart)),
          dispatch(setCartId(cartId)),
          dispatch(
            setUserCredentials({
              cartItemCount: getCartCount(cart),
              calculatedCurrentLoyaltyPoints: getCurrentLoyaltyPoints(cart),
            })
          ),
          // Store Cart, pointsEarned and statusCredits
          dispatch(setCartLoyaltyPoints(pointsEarned, statusCredits)),

          // Store BackOrder
          dispatch(setBackorderList(filterBackorder)),
        ]).then(async () => {
          // Check for discrepancies
          await dispatch(checkDiscrepancies())

          // Toggle false
          dispatch(toggleCartLoading(false))
          dispatch(toggleClearCartLoading(false))
        })
      })
      .catch((error) => {
        dispatch(toggleClearCartLoading(false))
        handleErrorMessage(error.message)
      })
  }
}

/**
 * Process for the readOneCart (PointsEarned and StatusCredits)
 *
 * @param allResponses
 */
const processeCartLoyaltyPointsFromServerResponse = (allResponses) => {
  let processedResponse = {
    pointsEarned: '0',
    statusCredits: '0',
  }

  allResponses.forEach((response) => {
    if (response?.data?.data?.readOneCart) {
      const endpointCall = response.data.data.readOneCart

      processedResponse['pointsEarned'] = endpointCall?.PointsEarned || '0'
      processedResponse['statusCredits'] = endpointCall?.StatusCredits || '0'
    }
  })

  return processedResponse
}

/**
 * Processes both readOneCart & readOneBackOrder and store it into respective groups
 *
 * @param allResponses
 */
export const getProcessedDataFromServerResponse = (allResponses) => {
  let processedResponse = {
    cart: {},
    backorder: {},
    permanentBackorder: {},
    products: {},
    cartId: '',
  }

  // Loop through all responses and get the buyableIDs and other information that need to be requested
  allResponses.forEach((response) => {
    let endpointCall, endpointType

    if (response?.data?.data?.readOneCart !== undefined) {
      endpointCall = response.data.data.readOneCart
      endpointType = 'cart'
      processedResponse['cartId'] = endpointCall?.ID
    } else if (response?.data?.data?.readOneBackOrder !== undefined) {
      endpointCall = response.data.data.readOneBackOrder
      endpointType = 'backorder'
    } else if (response?.data?.data?.readOnePermanentBackOrder !== undefined) {
      endpointCall = response.data.data.readOnePermanentBackOrder
      endpointType = 'permanentBackorder'
    } else if (response?.data?.data?.addCartOrderItems !== undefined) {
      endpointCall = response.data.data.addCartOrderItems
      endpointType = 'cart'
    }

    if (endpointCall) {
      endpointCall.Items?.edges?.forEach((orderItem) => {
        const { Buyable } = orderItem.node

        // Process data
        const cartItem = generateCartItem(orderItem.node)
        const { BuyableID, BundleType } = cartItem
        const cartKey = BuyableID

        if (BuyableID) {
          // Store Cart & BackOrder Responses
          if (processedResponse[endpointType][cartKey] === undefined) {
            processedResponse[endpointType][cartKey] = {}
          }

          processedResponse[endpointType][cartKey][BundleType] = cartItem

          // Store Products Responses
          processedResponse.products[BuyableID] = Buyable
        }
      })
    } else {
      createAlert(
        {
          message: 'Undefined endpointCall',
        },
        'error'
      )
    }
  })

  return processedResponse
}

/**
 * Overwrite whatever cart list data with the new one
 *
 * @param list
 * @returns {{type: string, list: *}}
 */
export const setCartList = (list) => {
  return {
    type: 'SET_CART_LIST',
    list: list,
  }
}

export const setCartId = (cartId) => {
  return {
    type: 'SET_CART_ID',
    value: cartId,
  }
}

/**
 * Update accumulated loyalty points
 *
 * @param list
 * @returns {{type: string, list: *}}
 */
export const setCartLoyaltyPoints = (pointsEarned, statusCredits) => {
  return {
    type: 'SET_CART_LOYALTY_POINTS',
    pointsEarned,
    statusCredits,
  }
}

/**
 * Check if the current cart & backorder SOH combination is not matching product's SOH
 *
 * @returns {Function}
 */
export const checkDiscrepancies = () => {
  return (dispatch, getState) => {
    // TODO
  }
}

export const updateCartItemWishlist = (product, target, value, forceAtLeastOneQty = false) => {
  return (dispatch, getState) => {
    const store = getState()
    const { caseQty = 0, case_price, unitQty = 0, unit_price } = product
    const cartId = store.cart.cartId
    dispatch(updateCoreValue(value))
    if (target === 'case') {
      if (value > caseQty) {
        segmentTrackWishlistProductAddedToCart(
          product,
          {
            price: case_price,
            variant: 'case',
            quantity: value - caseQty,
          },
          cartId
        )
      } else if (value < caseQty) {
        // No need this for segment. TBD
        // segmentTrackProductRemoved(
        //   product,
        //   {
        //     price: product?.case_price,
        //     variant: 'case',
        //     quantity: caseQty - value,
        //   },
        //   cartId
        // )
      }
    }

    if (target === 'unit') {
      if (value > unitQty) {
        segmentTrackWishlistProductAddedToCart(
          product,
          {
            price: unit_price,
            variant: 'unit',
            quantity: value - unitQty,
          },
          cartId
        )
      } else if (value < unitQty) {
        // No need this for segment. TBD
        // segmentTrackProductRemoved(
        //   product,
        //   {
        //     price: product?.unit_price,
        //     variant: 'unit',
        //     quantity: unitQty - value,
        //   },
        //   cartId
        // )
      }
    }

    dispatch(updateCartItem(product, target, value, forceAtLeastOneQty))
  }
}

const sendEvolutionRewardSegmentTrackProduct = (product, target, value, cartId, previousQty) => {
  //TODO
  const { caseTotal, case_price, unitTotal, unit_price } = product

  if (target === 'case') {
    if (value > previousQty) {
      segmentTrackProductAdded(
        product,
        {
          price: case_price,
          variant: 'case',
          quantity: value - previousQty,
        },
        cartId
      )
    } else if (value < previousQty) {
      segmentTrackProductRemoved(
        product,
        {
          price: case_price,
          variant: 'case',
          quantity: previousQty - value,
        },
        cartId
      )
    }
  }

  if (target === 'unit') {
    if (value > previousQty) {
      segmentTrackProductAdded(
        product,
        {
          price: unit_price,
          variant: 'unit',
          quantity: value - previousQty,
        },
        cartId
      )
    } else if (value < previousQty) {
      segmentTrackProductRemoved(
        product,
        {
          price: unit_price,
          variant: 'unit',
          quantity: previousQty - value,
        },
        cartId
      )
    }
  }
}

const sendSegmentTrackProduct = (product, target, value, cartId) => {
  const { caseTotal = 0, case_price, unitTotal = 0, unit_price } = product

  if (value === 0) {
    if (target === 'case') {
      segmentTrackProductRemoved(
        product,
        {
          price: case_price,
          variant: target,
          quantity: caseTotal,
        },
        cartId
      )
    }

    if (target === 'unit' && unitTotal > 0) {
      segmentTrackProductRemoved(
        product,
        {
          price: unit_price,
          variant: target,
          quantity: unitTotal,
        },
        cartId
      )
    }
  } else {
    if (target === 'case') {
      if (value > caseTotal) {
        segmentTrackProductAdded(
          product,
          {
            price: case_price,
            variant: 'case',
            quantity: value - caseTotal,
          },
          cartId
        )
      } else if (value < caseTotal) {
        segmentTrackProductRemoved(
          product,
          {
            price: case_price,
            variant: 'case',
            quantity: caseTotal - value,
          },
          cartId
        )
      }
    }

    if (target === 'unit') {
      if (value > unitTotal) {
        segmentTrackProductAdded(
          product,
          {
            price: unit_price,
            variant: 'unit',
            quantity: value - unitTotal,
          },
          cartId
        )
      } else if (value < unitTotal) {
        segmentTrackProductRemoved(
          product,
          {
            price: unit_price,
            variant: 'unit',
            quantity: unitTotal - value,
          },
          cartId
        )
      }
    }
  }
}

export const updateCartItemProduct = (product, target, value, forceAtLeastOneQty = false) => {
  return (dispatch, getState) => {
    const store = getState()
    const { webCategory } = product
    const cartId = store.cart.cartId

    if (webCategory === 'Evolution Rewards') {
      // ignore the rest condition
      dispatch(updateCartItem(product, target, value, forceAtLeastOneQty))
      return
    }

    sendSegmentTrackProduct(product, target, value, cartId)

    dispatch(updateCartItem(product, target, value, forceAtLeastOneQty))
  }
}

/**
 * Update cart item (mostly quantity) and then fires to reducer and sync to server at later's stage
 *
 * @param product
 * @param target
 * @param value
 * @param forceAtLeastOneQty
 * @returns {function(*, *): Promise<unknown[]>}
 */
export const updateCartItem = (product, target, num, forceAtLeastOneQty = false, calledFor = '') => {
  // TODO: forceAtLeastOneQty is always false /shrug
  return (dispatch, getState) => {
    const store = getState()

    /*
      Convert units to cases if units entered are equal to a case to manage subcharges 
    */
    let isUnitConverted = false
    let calculatedCases = 1
    if (target == 'unit' && !product?.sell_by_case && product?.qty_per_case && num / product?.qty_per_case >= 1) {
      let newValue = num % product?.qty_per_case
      calculatedCases = (num - newValue) / product?.qty_per_case || 1
      num = newValue
      isUnitConverted = true
    }

    let value = num
    if (calledFor !== 'MaxLimit') {
      let prevTotalCases = 0
      if (product?.sell_by_case) {
        prevTotalCases = product?.caseTotal * product.wholesale_unit_per_case
      } else {
        prevTotalCases = product?.caseTotal * product.qty_per_case + product?.unitTotal
      }

      if (target == 'case' && value >= 0 && prevTotalCases > product?.MaxUnitValue && value < product?.caseTotal) {
        // value = product?.MaxValue
      } else if (
        target == 'unit' &&
        value >= 0 &&
        prevTotalCases > product?.MaxUnitValue &&
        value < product?.unitTotal
      ) {
        // let prevCaseUnits = product?.caseTotal * product.qty_per_case
        // let remainingUnits = product?.MaxUnitValue - prevCaseUnits
        // if (remainingUnits >= 0) {
        //   value = remainingUnits
        // } else {
        //   value = 0
        // }
      } else {
        if (target == 'case' && value > 0 && product?.unitTotal > 0 && product?.MaxValue >= 0) {
          let casesInUnits = value * product.qty_per_case
          let totalUnits = product?.unitTotal + casesInUnits
          if (totalUnits > product?.MaxUnitValue) {
            return false
          }
        } else if (target == 'unit' && value > 0 && product?.caseTotal > 0 && product?.MaxUnitValue >= 0) {
          let currentUnits = product?.caseTotal * product.qty_per_case
          let remainingUnits = product?.MaxUnitValue - currentUnits
          if (value > remainingUnits) {
            return false
          }
        } else if (target == 'case' && product?.MaxValue >= 0 && value > product?.MaxValue) {
          return false
        } else if (target == 'unit' && product?.MaxUnitValue >= 0 && value > product?.MaxUnitValue) {
          return false
        }
      }
    }

    dispatch(toggleCartCheckoutButtonLoading(true))

    const {
      id,
      sell_by_case,
      qty_per_case,
      wholesale_unit_per_case,
      soh,
      webCategory,
      loyaltyPoints,
      caseQty,
      unitQty,
    } = product

    dispatch(setCartSelectedProduct(id))

    let caseSize = sell_by_case ? wholesale_unit_per_case : qty_per_case

    // Get total quantity in both cart & backorder in units / case depending on sell_by_case
    // ------------------
    const cartList = store.cart.list
    const backOrderList = store.backorder.list
    const products = store.products.list
    const isSuperWholesaler = store.user.isSuperWholesaler
    const cartId = store.cart.cartId

    const cartItem = cartList[id] || false
    const backOrderItem = backOrderList[id] || false

    const cartItemID = cartItem ? cartItem.ID : null
    const backOrderItemID = backOrderItem ? backOrderItem.ID : null

    if (webCategory === 'Evolution Rewards') {
      if (value === 0) {
        dispatch(removeCartItem(product))

        return
      }

      if (value > soh) {
        value = soh
        createAlert(
          {
            message: 'Not enough stock available',
          },
          'warning'
        )
      }

      let previousQty = value
      let cartReducerPayload = {
        ...cartList,
        [id]: {
          case: generateCartItemPayload(product, cartItemID, 'case', value),
        },
      }

      const calculatedCurrentLoyaltyPoints = getCurrentLoyaltyPoints(cartReducerPayload)

      delete cartReducerPayload[id]
      const calculatedOtherLoyaltyPoints = getCurrentLoyaltyPoints(cartReducerPayload)
      const calculatedTotalLoyaltyPoints = store.user.calculatedTotalLoyaltyPoints

      /**
       * https://jira.visualr.dev/browse/PAR-1725
       * Fall back to max possible quantity instead of previous one
       */
      if (calculatedCurrentLoyaltyPoints > calculatedTotalLoyaltyPoints) {
        value = Math.floor((calculatedTotalLoyaltyPoints - calculatedOtherLoyaltyPoints) / loyaltyPoints)
        createAlert(
          {
            message: 'Not enough Redeemable Points available',
          },
          'error'
        )
      }

      cartReducerPayload = {
        ...cartList,
        [id]: {
          case: generateCartItemPayload(product, cartItemID, 'case', value),
        },
      }

      // TODO
      //sendEvolutionRewardSegmentTrackProduct(product, target, value, cartId, previousQty)

      dispatch(setCartList(cartReducerPayload))
      debounceDispatchFunction(dispatch, sendCartData, [], { product, target, num, forceAtLeastOneQty })

      /*
        Update cases qty in cart after converting units to cases
      */
      if (isUnitConverted) {
        dispatch(
          updateCartItemProduct(
            product,
            'case',
            parseInt(product?.caseTotal || 0) + parseInt(calculatedCases || 0),
            false
          )
        )
      }
      return
    }

    const displayCart = combineCartBackOrderData(products, cartList, backOrderList, store)
    let currentDisplayCartItem = displayCart[id] || false

    let originalTotalUnits = currentDisplayCartItem
      ? currentDisplayCartItem.caseTotal * caseSize + currentDisplayCartItem.unitTotal
      : 0

    let isSomethingChange = false
    let caseTotal = target === 'case' ? value : currentDisplayCartItem ? currentDisplayCartItem.caseTotal : 0
    let unitTotal = target === 'unit' ? value : currentDisplayCartItem ? currentDisplayCartItem.unitTotal : 0

    // If we don't have existing cart item, let's create one
    if (!currentDisplayCartItem) {
      currentDisplayCartItem = getCartItemValues(product, { caseQty: caseTotal, unitQty: unitTotal })
      isSomethingChange = true
    }

    // If force forceAtLeastOneQty = true, we need to set either caseTotal or unitTotal to be 1 as the lowest
    if (forceAtLeastOneQty && soh > 0 && caseTotal == 0 && unitTotal == 0) {
      if (product?.MaxValue >= 0 || product?.MaxUnitValue >= 0) {
        if (sell_by_case && product?.MaxValue >= 1) {
          caseTotal = 1
        } else {
          if (target === 'unit' && caseTotal == 0 && product?.MaxUnitValue >= 1) {
            unitTotal = 1
          } else if (target === 'case' && unitTotal == 0 && product?.MaxValue >= 1) {
            caseTotal = 1
          }
        }
      } else {
        if (sell_by_case) {
          caseTotal = 1
        } else {
          if (target === 'unit' && caseTotal == 0) {
            unitTotal = 1
          } else if (target === 'case' && unitTotal == 0) {
            caseTotal = 1
          }
        }
      }
    }
    const totalUnits = caseTotal * caseSize + unitTotal

    // Oh but before that, let's check if there is anything different (if we have existing cart item mostly)
    if (originalTotalUnits !== totalUnits) {
      isSomethingChange = true
    }

    if (!isUnitConverted && !isSomethingChange) {
      // Nothing changes, skip doing anything
      console.log('nothing changes, skip ~')
      return
    }

    // Divide the cart & backorder units / case based on soh
    // ------------------
    let availableUnits = totalUnits > soh ? soh : totalUnits
    let overflownUnits = Math.max(totalUnits - soh, 0)

    // Ensure cart & backorder will not have overflowing case & units
    // ------------------
    let newCartItemQty_case = 0
    let newCartItemQty_unit = 0

    let newBackorderItemQty_case = 0
    let newBackorderItemQty_unit = 0

    // Calculate case first
    if (availableUnits > caseTotal * caseSize) {
      newCartItemQty_case = caseTotal
      newBackorderItemQty_case = 0

      // Reduce the available units
      availableUnits -= caseTotal * caseSize
    } else {
      newCartItemQty_case = Math.floor(availableUnits / caseSize)
      newBackorderItemQty_case = caseTotal - newCartItemQty_case

      // Reduce the available units
      availableUnits -= newCartItemQty_case * caseSize
    }

    // Then units
    if (availableUnits > unitTotal) {
      newCartItemQty_unit = unitTotal
      newBackorderItemQty_unit = 0

      // Reduce the available units
      availableUnits -= unitTotal
    } else {
      newCartItemQty_unit = availableUnits
      newBackorderItemQty_unit = unitTotal - newCartItemQty_unit

      // Reduce the available units
      availableUnits -= newBackorderItemQty_unit
    }

    const { hideBackOrderSuppliers } = store?.user?.globalConfig
    // Store to CartReducer & BackorderReducer
    // ------------------
    let cartReducerPayload = {
      ...cartList,
      [id]: {
        case: generateCartItemPayload(product, cartItemID, 'case', newCartItemQty_case),
        unit: generateCartItemPayload(product, cartItemID, 'unit', newCartItemQty_unit),
      },
    }

    let backOrderReducerPayload = {
      ...backOrderList,
      [id]: {
        case: generateCartItemPayload(product, backOrderItemID, 'case', newBackorderItemQty_case),
        unit: generateCartItemPayload(product, backOrderItemID, 'unit', newBackorderItemQty_unit),
      },
    }

    // If sell_by_case, remove unit payload because we don't need it
    if (sell_by_case) {
      delete cartReducerPayload[id].unit
      delete backOrderReducerPayload[id].unit
    }

    dispatch(setCartList(cartReducerPayload))
    if (hideBackOrderSuppliers && hideBackOrderSuppliers?.includes(product?.supplierID)) {
      console.log('Backorder not allowed.')
    } else {
      dispatch(setBackorderList(backOrderReducerPayload))
    }
    /**
     * Dont do any loyalty points calculation for super-wholesaler level
     */
    if (!isSuperWholesaler) {
      dispatch(updateCartLoyaltyPoints())
    }

    const sku = product?.sku
    dispatch(requestProductDeals())
    debounceDispatchFunction(dispatch, sendCartData, [], { product, target, num, forceAtLeastOneQty })

    /*
      Update cases qty in cart after converting units to cases
    */
    if (isUnitConverted) {
      dispatch(
        updateCartItemProduct(
          product,
          'case',
          parseInt(product?.caseTotal || 0) + parseInt(calculatedCases || 0),
          false
        )
      )
    }
    return
    // const cartList = store.cart.list;
    // const { id, sell_by_case, soh } = product;
    //
    // // For supplier, the cart key is product's id
    // const cartProduct = cartList[id];
    //
    // let caseTotal = target === 'case' ? value : (cartProduct ? cartProduct.caseTotal : 0);
    // let unitTotal = target === 'unit' ? value : (cartProduct ? cartProduct.unitTotal : 0);
    //
    // // If force forceAtLeastOneQty = true, we need to set either caseTotal or unitTotal to be 1
    // if(forceAtLeastOneQty && soh > 0 && caseTotal == 0 && unitTotal == 0) {
    //     if(sell_by_case) {
    //         caseTotal = 1;
    //     } else {
    //         if(target === 'unit' && caseTotal == 0) {
    //             unitTotal = 1;
    //         } else if(target === 'case' && unitTotal == 0) {
    //             caseTotal = 1;
    //         }
    //     }
    // }
    //
    // const newList = {
    //     [id]: getCartItemValues(product, { caseQty: caseTotal, unitQty: unitTotal})
    // };
    //
    // return Promise.all([
    //     // dispatch(requestProductPriceByID(id)), // TODO: Check if we still need this
    //     dispatch(updateCartItems(newList)),
    // ]);
  }
}

// -----------------------------------------

export const updateCartLoyaltyPoints = (pointsEarned, statusCredits) => {
  return (dispatch, getState) => {
    const { cart } = getState()
    const cartPoints = getCartTotalPoints(cart)

    dispatch(setCartLoyaltyPoints(cartPoints.pointsEarned, cartPoints.statusCredits))
  }
}

export const getCartData = (cart) => {
  const cartData = []
  Object.entries(cart).map(([key, value]) => {
    const { qty_per_case, caseTotal, unitTotal } = value
    cartData.push({
      id: key,
      qty: caseTotal * qty_per_case + unitTotal,
    })
  })
  return cartData
}
export const getProcessedCartData = (store) => {
  const cartList = store.cart.list
  const backOrderList = store.backorder.list

  const cartData = {}

  ;[cartList, backOrderList].forEach((list) => {
    Object.values(list).forEach((bundles) => {
      Object.values(bundles).forEach(({ BuyableID, TotalUnitItems, BundleType, ItemsInCase }) => {
        const cartKey = `${BuyableID}-${BundleType}`

        if (cartData[cartKey] === undefined) {
          cartData[cartKey] = {
            BuyableID,
            BundleType,
            TotalUnitItems: 0,
          }
        }

        cartData[cartKey].TotalUnitItems += TotalUnitItems
      })
    })
  })

  return Object.values(cartData)
}
export const sendCartData = (extraData = [], cartObj = {}) => {
  return (dispatch, getState) => {
    const state = getState()
    const cartData = getProcessedCartData(state)
    console.log('cartObj ====', { cartObj })
    const selectedProductID = state.cart.selectedProductID

    dispatch(toggleCartCheckoutButtonLoading(true))
    toggleOnBeforeUnload(true)

    const combinedData = [...cartData, ...extraData].filter((item) => {
      return selectedProductID.find((ID) => ID === item['BuyableID'])
    })

    dispatch(clearCartSelectedProduct())

    if (combinedData.length === 0) {
      toggleOnBeforeUnload(false)
      dispatch(toggleCartCheckoutButtonLoading(false))

      return
    }

    return axiosUpdateCart(combinedData)
      .then((response) => {
        const allResponses = [response]

        const processedResponse = getProcessedDataFromServerResponse(allResponses)

        const { cart } = processedResponse

        dispatch(
          setUserCredentials({
            cartItemCount: getCartCount(cart),
            calculatedCurrentLoyaltyPoints: getCurrentLoyaltyPoints(cart),
          })
        )

        // dispatch(
        //   setUserCredentials({
        //     calculatedCurrentLoyaltyPoints: 0,
        //   })
        // )

        toggleOnBeforeUnload(false)
        dispatch(toggleCartCheckoutButtonLoading(false))
      })
      .catch((error) => {
        console.log('error.message', error.message)
        if (error?.message === 'Quantity requested greater than Maximum Allocated Value') {
          if (Object.keys(cartObj).length > 0) {
            const { product, target, num, forceAtLeastOneQty } = cartObj
            dispatch(requestProductRules())
            dispatch(updateCartItem(product, target, num, forceAtLeastOneQty, 'MaxLimit'))
          }
        } else {
          handleErrorMessage(error.message)
        }
      })
  }
}

export const checkout = () => {
  return async (dispatch, getState) => {
    dispatch(toggleCartLoading(true))
    await dispatch(sendCartData())

    window.location.href = '/wholesaler/checkout'
  }
}
export const toggleCart = (value) => {
  return async (dispatch, getState) => {
    dispatch({
      type: 'TOGGLE_CART',
      value: value,
    })
    const state = getState()
    const { cart } = state

    if (!cart.display) {
      return
    }

    if (typeof window.supplierID === 'undefined' || window.supplierID == 0) {
      await dispatch(requestCart())
      let state = getState()

      const products = state.products.list
      const cart = state.cart.list
      const cartId = state.cart.cartId

      return dispatch(segmentTrackCartViewed(products, cart, cartId))
    }
  }
}
export const toggleCartLoading = (value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'TOGGLE_CART_LOADING',
      value: value,
    })
  }
}

export const toggleClearCartLoading = (value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'TOGGLE_CLEAR_CART_LOADING',
      value: value,
    })
  }
}

export const toggleCartCheckoutButtonLoading = (value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'TOGGLE_CART_CHECKOUT_BUTTON_LOADING',
      value: value,
    })
  }
}
export const updateCoreValue = (value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'TOGGLE_ORDER_TEMPLATE_COREVALUE',
      value: value,
    })
  }
}
export const setCartSelectedProduct = (id) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'SET_CART_SELECTED_PRODUCT',
      value: id,
    })
  }
}
export const clearCartSelectedProduct = (id) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'CLEAR_CART_SELECTED_PRODUCT',
    })
  }
}
export const requestCart = () => {
  return async (dispatch, getState) => {
    const state = getState()
    const { cart } = state

    if (!Object.entries(cart.list).length) {
      return
    }

    await dispatch(sendCartData())

    return dispatch(requestFromServer())
  }
}
export const removeCartItem = (product) => {
  return async (dispatch, getState) => {
    const store = getState()
    const cartId = store.cart.cartId

    const { id, caseQty, case_price, unitQty, unit_price, sell_by_case } = product

    if (caseQty > 0 && case_price > 0) {
      segmentTrackProductRemoved(
        product,
        {
          price: case_price,
          variant: 'case',
          quantity: caseQty,
        },
        cartId
      )
    }

    if (!sell_by_case && unitQty > 0 && unit_price > 0) {
      segmentTrackProductRemoved(
        product,
        {
          price: unit_price,
          variant: 'unit',
          quantity: unitQty,
        },
        cartId
      )
    }

    const isSuperWholesaler = store.user.isSuperWholesaler

    dispatch(setCartSelectedProduct(id))

    dispatch({
      type: 'REMOVE_CART_ITEM',
      product: product,
    })
    dispatch({
      type: 'REMOVE_BACKORDER_ITEM',
      product: product,
    })

    const cartData = [
      {
        BuyableID: product.id,
        BundleType: 'case',
        TotalUnitItems: 0,
      },
      {
        BuyableID: product.id,
        BundleType: 'unit',
        TotalUnitItems: 0,
      },
    ]

    /**
     * Dont do any loyalty points calculation for super-wholesaler level
     */
    if (!isSuperWholesaler) {
      dispatch(updateCartLoyaltyPoints())
    }

    await dispatch(sendCartData(cartData))

    // TODO: this shouldn't be here
    if (document.getElementById('checkout')) {
      dispatch(requestCheckoutCart())
    }
  }
}

export const emptyCartWholesaler = (products) => {
  return async (dispatch, getState) => {
    const store = getState()
    let cartItems = []

    dispatch(toggleClearCartLoading(true))

    if (products && Object.keys(products).length > 0) {
      for (let [key, value] of Object.entries(products)) {
        if (key) {
          cartItems.push({
            BuyableID: key,
            BundleType: 'case',
            TotalUnitItems: 0,
          })
        }

        if (value && value?.sell_by_case == false) {
          cartItems.push({
            BuyableID: key,
            BundleType: 'unit',
            TotalUnitItems: 0,
          })
        }
      }
    }

    return axiosUpdateCart(cartItems)
      .then((response) => {
        // const allResponses = [response]
        // const processedResponse = getProcessedDataFromServerResponse(allResponses)
        // const { cart } = processedResponse
        dispatch(setCartList([]))
        dispatch(setBackorderList([]))
        dispatch(setCartLoyaltyPoints(0, 0)), dispatch(requestFromServer())
        toggleOnBeforeUnload(false)
        dispatch(toggleCartCheckoutButtonLoading(false))
      })
      .catch((error) => {
        dispatch(toggleClearCartLoading(false))
        handleErrorMessage(error.message)
      })
  }
}

export const updateCart = () => {
  return (dispatch, getState) => {
    const state = getState()
    const { cart } = state
    const list = getProductsFullInfo(cart.list, state)
    let hasItemsMovedToCart = false
    let hasItemsMovedToBackOrder = false
    const newList = Object.values(list).reduce((items, item) => {
      const caseTotal = item.caseTotal
      const unitTotal = item.unitTotal
      items[item.id] = getCartItemValues(item, { caseQty: caseTotal, unitQty: unitTotal })

      const { caseBackOrder, unitBackOrder } = items[item.id]

      // backOrder moved to cart
      if (item.caseBackOrder < caseBackOrder || item.unitBackOrder < unitBackOrder) {
        hasItemsMovedToBackOrder = true
      }
      // backOrder moved to cart
      if (item.caseBackOrder > caseBackOrder || item.unitBackOrder > unitBackOrder) {
        hasItemsMovedToCart = true
      }

      return items
    }, {})

    dispatch(updateCartItems(newList))
    dispatch(updateItemsMovedToCart(hasItemsMovedToCart))
    dispatch(updateItemsMovedToBackOrder(hasItemsMovedToBackOrder))
  }
}
export const updateItemsMovedToCart = (value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'UPDATE_ITEMS_MOVED_TO_CART',
      value: value,
    })
  }
}
export const updateItemsMovedToBackOrder = (value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'UPDATE_ITEMS_MOVED_TO_BACK_ORDER',
      value: value,
    })
  }
}
export const replaceProduct = (product, replacement) => {
  // TODO: review this and updateCartItem logic. They should be similar and simplified
  return async (dispatch, getState) => {
    const store = getState()

    const cartList = store.cart.list
    const backOrderList = store.backorder.list
    const products = store.products.list

    // Get backorder item of this product
    const displayCart = combineCartBackOrderData(products, cartList, backOrderList, store)

    const currentProductCartItem = displayCart[product.id] || false
    const currentReplacementCartItem = displayCart[replacement.id] || false

    // Add the case of this product to the new replacement
    if (currentProductCartItem) {
      await dispatch(toggleProductReplacementsLoading(true))

      const totalBackOrderInUnits =
        currentProductCartItem.caseBackOrder * currentProductCartItem.qty_per_case +
        currentProductCartItem.unitBackOrder

      const currentReplacementCaseTotal = currentReplacementCartItem ? currentReplacementCartItem.caseTotal : 0
      const currentReplacementUnitTotal = currentReplacementCartItem ? currentReplacementCartItem.unitTotal : 0

      // (If available) Add the unit of this product to the new replacement
      if (replacement.sell_by_case) {
        await dispatch(
          updateCartItem(
            replacement,
            'case',
            currentReplacementCaseTotal + Math.ceil(totalBackOrderInUnits / replacement.qty_per_case),
            false
          )
        )
      } else {
        await dispatch(
          updateCartItem(
            replacement,
            'case',
            currentReplacementCaseTotal + Math.floor(totalBackOrderInUnits / replacement.qty_per_case),
            false
          )
        )
        await dispatch(
          updateCartItem(
            replacement,
            'unit',
            currentReplacementUnitTotal + (totalBackOrderInUnits % replacement.qty_per_case),
            false
          )
        )
      }

      // Remove backorder item
      const { [product.id]: removedBackOrderItem, ...remainingBackOrder } = backOrderList

      // Set it to 0 so it can sync with backend
      if (removedBackOrderItem.case) {
        removedBackOrderItem.case.TotalUnitItems = 0
      }
      if (removedBackOrderItem.unit) {
        removedBackOrderItem.unit.TotalUnitItems = 0
      }

      dispatch(
        setBackorderList({
          ...remainingBackOrder,
          [product.id]: removedBackOrderItem,
        })
      )

      // Then save
      await dispatch(sendCartData())

      dispatch(toggleProductReplacementsLoading(false))

      createAlert(
        {
          status: 1,
          message: '<u>' + product.title + '</u> has been replaced with <u>' + replacement.title + '</u>',
        },
        'success'
      )
    }

    closeProductGridModal()

    // const { cart } = getState();
    // const { soh, caseBackOrder, unitBackOrder } = product;
    // const cartProduct = cart.list[replacement.id];
    // const caseTotal = caseBackOrder + (cartProduct && cartProduct.caseTotal ? cartProduct.caseTotal : 0);
    // const unitTotal = unitBackOrder + (cartProduct && cartProduct.unitTotal ? cartProduct.unitTotal : 0);
    // const newList = {
    //     [product.id]: getCartItemValues(product, { caseQty: soh, unitQty: 0}),
    //     [replacement.id]: getCartItemValues(replacement, { caseQty: caseTotal, unitQty: unitTotal})
    // };
    //
    // dispatch(updateCartItems(newList));
    //
    // createAlert({
    //     status: 1,
    //     message: '<u>' + product.title + '</u> has been replaced with <u>' + replacement.title + '</u>',
    // }, 'success');
    //
    // closeProductGridModal();
  }
}

export const getCartItemValues = (product, values) => {
  const { id, qty_per_case, sell_by_case, soh, created } = product
  const availability = soh
  let valuesAdded, caseQty, unitQty

  if (sell_by_case) {
    valuesAdded = (values.caseQty || 0) * qty_per_case
    caseQty = Math.floor(valuesAdded / qty_per_case)
    unitQty = 0
  } else {
    valuesAdded = (values.caseQty || 0) * qty_per_case + (values.unitQty || 0)
    caseQty = Math.floor(valuesAdded / qty_per_case)
    unitQty = valuesAdded % qty_per_case
  }

  const caseTotal = caseQty
  const unitTotal = unitQty

  let baseCartData = {
    id: id,
    created: created || null,
  }

  if (id == 13) {
    console.log('debug', availability, valuesAdded)
  }

  // no back order
  if (availability >= valuesAdded) {
    return {
      ...baseCartData,
      caseQty: caseTotal,
      unitQty: 0,
      caseBackOrder: 0,
      unitBackOrder: 0,
      caseTotal: caseTotal,
      unitTotal: unitTotal,
      totalQtyForBE: valuesAdded,
    }
  }

  // there is a back order
  if (sell_by_case) {
    const overflowed = valuesAdded - availability
    const overflowedCase = Math.ceil(overflowed / qty_per_case)

    return {
      ...baseCartData,
      caseQty: caseTotal - overflowedCase,
      unitQty: 0,
      caseBackOrder: overflowedCase,
      unitBackOrder: 0,
      caseTotal: caseTotal,
      unitTotal: 0,
      totalQtyForBE: Math.floor(soh / qty_per_case),
    }

    // return {
    //     ...baseCartData,
    //     caseQty: soh,
    //     unitQty: 0,
    //     caseBackOrder: caseTotal - soh,
    //     unitBackOrder: 0,
    //     caseTotal: caseTotal,
    //     unitTotal: 0,
    //     totalQtyForBE: soh * qty_per_case,
    // };
  } else {
    const overflowed = valuesAdded - availability
    const overflowedCase = Math.floor(overflowed / qty_per_case)
    const overflowedUnits = overflowed % qty_per_case

    return {
      ...baseCartData,
      caseQty: caseTotal - overflowedCase,
      unitQty: unitTotal - overflowedUnits,
      caseBackOrder: overflowedCase,
      unitBackOrder: overflowedUnits,
      caseTotal: caseTotal,
      unitTotal: unitTotal,
      totalQtyForBE: soh,
    }
  }

  // const { id, qty_per_case, soh } = product;
  // const availableUnits = soh * qty_per_case;
  // const valuesUnits = (values.caseQty || 0) * qty_per_case + (values.unitQty || 0);
  // const caseQty = Math.floor(valuesUnits / qty_per_case);
  // const unitQty = valuesUnits % qty_per_case;
  // const caseTotal = caseQty;
  // const unitTotal = unitQty;
  //
  // // no back order
  // if (availableUnits >= valuesUnits) {
  //     return {
  //         id: id,
  //         caseQty: caseTotal,
  //         unitQty: unitTotal,
  //         caseBackOrder: 0,
  //         unitBackOrder: 0,
  //         caseTotal: caseTotal,
  //         unitTotal: unitTotal,
  //     };
  // }
  //
  // // there is a back order
  // return {
  //     id: id,
  //     caseQty: soh,
  //     unitQty: 0,
  //     caseBackOrder: caseTotal - soh,
  //     unitBackOrder: unitTotal,
  //     caseTotal: caseTotal,
  //     unitTotal: unitTotal,
  // };
}
export const updateCartItems = (list) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'UPDATE_CART_ITEMS',
      list: list,
    })
  }
}
export const toggleOnBeforeUnload = (status) => {
  if (status) {
    window.onbeforeunload = function () {
      return 'Your items are being processed, are you sure you want to quit?'
    }
  } else {
    window.onbeforeunload = function () {
      // blank function do nothing
    }
  }
}
export const updateCartReport = (report) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'UPDATE_CART_REPORT',
      data: report,
    })
  }
}

// TODO: this function needs to be updated (calculation of cases/units) or removed
// export const clearCart = () => {
//   return (dispatch, getState) => {
//     const state = getState()
//     const cartList = state.cart.list
//     let newCartList = {}

//     Object.entries(cartList).map(([key, value]) => {
//       const newCaseTotal = value.caseTotal - value.caseQty
//       const newUnitTotal = value.unitTotal - value.unitQty

//       newCartList[key] = {
//         ...value,
//         caseTotal: newCaseTotal > 0 ? newCaseTotal : 0,
//         caseQty: 0,
//         unitTotal: newUnitTotal > 0 ? newUnitTotal : 0,
//         unitQty: 0,
//       }
//     })

//     dispatch(updateCartItems(newCartList))
//   }
// }
export const axiosRequestCartFromServer = () => {
  let { url, query } = config.cart.list

  if (cancelToken.requestCart) {
    cancelToken.requestCart.cancel()
  }

  cancelToken.requestCart = createAxiosCancellationToken()

  return axios.get(url, {
    params: {
      query: query,
    },
    withCredentials: true,
    cancelToken: cancelToken.requestCart.token,
  })
}
export const axiosUpdateCart = (cartData) => {
  if (cartData?.length == 0) {
    return false
  }
  const { url, query } = config.cart.update

  const params = {
    query: query,
    variables: {
      Buyables: cartData,
    },
  }

  /**
   * POST method in NOT idempotent
   * Even if the request is cancelled, server still receive and update the data
   * this may cause data inconsistency between FE & BE
   */

  // if (cancelToken.updateCart) {
  //   cancelToken.updateCart.cancel()
  // }

  //cancelToken.updateCart = createAxiosCancellationToken()

  // return axios.post(url, params, {
  //   withCredentials: true,
  //   //cancelToken: cancelToken.updateCart.token,
  // })
  return axios.post(url, params, {
    withCredentials: true,
    //cancelToken: cancelToken.updateCart.token,
  })
}
export const axiosUpdateCartItemQuantity = (id, qty) => {
  const { url, query } = config.cart.updateItemQuantity

  let params = {
    query: query,
    variables: {
      ID: id,
      TotalUnitItems: qty,
    },
  }

  return axios.post(url, params, {
    withCredentials: true,
  })
}
export const axiosRemoveCartItem = (id) => {
  const { url, query } = config.cart.deleteItem

  let params = {
    query: query,
    variables: {
      ID: id,
    },
  }

  return axios.post(url, params, {
    withCredentials: true,
  })
}

export const axiosRemoveAllCartItems = (ids) => {
  const { url, query } = config.cart.deleteAllItems

  let params = {
    query: query,
    variables: {
      IDs: ids,
    },
  }

  return axios.post(url, params, {
    withCredentials: true,
  })
}

export const axiosRequestBackOrderFromServer = (customerID = 0) => {
  let { url, query } = config.backorder.list

  if (cancelToken.requestBackOrder) {
    cancelToken.requestBackOrder.cancel()
  }

  cancelToken.requestBackOrder = createAxiosCancellationToken()

  return axios.get(url, {
    params: {
      query: query,
    },
    withCredentials: true,
    cancelToken: cancelToken.requestBackOrder.token,
  })
}
